import React from 'react';

const StatCard = ({ title, value, icon: Icon, color = 'railway', subtitle }) => {
  const colors = {
    railway: 'from-railway-500 to-railway-600',
    green: 'from-green-500 to-green-600',
    blue: 'from-blue-500 to-blue-600',
    purple: 'from-purple-500 to-purple-600',
    orange: 'from-orange-500 to-orange-600',
    red: 'from-red-500 to-red-600',
    midnight: 'from-midnight-700 to-midnight-800',
  };

  return (
    <div className="card overflow-hidden">
      <div className={`bg-gradient-to-br ${colors[color]} p-6`}>
        <div className="flex items-start justify-between">
          <div>
            <p className="text-white/80 text-sm font-medium">{title}</p>
            <p className="text-3xl font-display font-bold text-white mt-1">{value}</p>
            {subtitle && (
              <p className="text-white/60 text-xs mt-2">{subtitle}</p>
            )}
          </div>
          {Icon && (
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <Icon className="w-6 h-6 text-white" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
